// 公開ページの SEO 定義。
//
// 各ページの <SEOHead> と、ビルド時にルート別 HTML を生成する vite.config.ts の
// seoPagesPlugin の両方から参照する。検索エンジンは JS 実行前の生 HTML の
// canonical / title も見るため、両者の内容を一致させる必要がある。
// vite.config.ts（Node）からも読み込まれるので、React やブラウザ API に依存させないこと。
//
// 固定ページを増減したら app/router/sitemap_routes.go の一覧も合わせて更新する。

export const SITE_NAME = "都建設株式会社";
export const BASE_URL = "https://miyako-kensetsu-ehime.com";
export const DEFAULT_TITLE = `${SITE_NAME} | 愛媛県西予市の解体工事・土木工事`;
export const DEFAULT_DESCRIPTION =
  "都建設株式会社は愛媛県西予市を拠点に、解体工事、住宅等造成工事、土木工事、ガーデニング工事を展開。安心安全な街づくりをモットーに、お客様のご要望に最善の施工方法をご提案いたします。";
export const DEFAULT_OG_IMAGE = `${BASE_URL}/images/ogp.jpg`;

export interface StaticPageSEO {
  // ルートパス（canonical の基準。末尾スラッシュなし）
  path: string;
  // ページ名（未指定ならサイト既定のタイトル）
  title?: string;
  description: string;
  keywords: string;
}

export const STATIC_PAGES = {
  home: {
    path: "/",
    description: DEFAULT_DESCRIPTION,
    keywords: "都建設,解体工事,土木工事,ガーデニング工事,造成工事,愛媛県,西予市,宇和町,建設会社",
  },
  about: {
    path: "/about",
    title: "会社概要",
    description:
      "都建設株式会社の会社概要。愛媛県西予市を拠点に解体工事、土木工事、ガーデニング工事を展開しています。",
    keywords: "都建設,会社概要,企業情報,愛媛県,西予市,解体工事,土木工事",
  },
  services: {
    path: "/services",
    title: "業務内容",
    description:
      "都建設株式会社の業務内容。建築工事、解体工事、土木工事、ガーデニング工事、住宅等造成工事など幅広いサービスを提供しています。",
    keywords: "都建設,業務内容,建築工事,解体工事,土木工事,ガーデニング工事,造成工事,愛媛県,西予市",
  },
  works: {
    path: "/works",
    title: "施工実績",
    description:
      "都建設株式会社の施工実績。解体工事、土木工事、ガーデニング工事、造成工事など、豊富な実績をご覧ください。",
    keywords: "都建設,施工実績,施工事例,解体工事,土木工事,ガーデニング工事,愛媛県,西予市",
  },
  recruit: {
    path: "/recruit",
    title: "採用情報",
    description:
      "都建設株式会社の採用情報。未経験者も安心の職場環境と充実した福利厚生をご用意しております。",
    keywords: "都建設,採用情報,求人,愛媛県,西予市,福利厚生,資格支援制度",
  },
  contact: {
    path: "/contact",
    title: "お問い合わせ",
    description:
      "都建設株式会社へのお問い合わせページ。お見積もり、ご相談など、お気軽にお問い合わせください。",
    keywords: "都建設,お問い合わせ,見積もり,相談,愛媛県,西予市",
  },
  privacyPolicy: {
    path: "/privacy-policy",
    title: "プライバシーポリシー",
    description:
      "都建設株式会社のプライバシーポリシー。個人情報の取り扱いについて説明しています。",
    keywords: "都建設,プライバシーポリシー,個人情報保護,個人情報取扱",
  },
  news: {
    path: "/news",
    title: "お知らせ",
    description:
      "都建設株式会社からのお知らせ一覧。最新情報や活動報告をご覧いただけます。",
    keywords: "都建設,お知らせ,ニュース,最新情報,活動報告",
  },
} satisfies Record<string, StaticPageSEO>;

export const buildFullTitle = (title?: string): string =>
  title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;

export const buildCanonicalUrl = (path: string): string =>
  path === "/" ? `${BASE_URL}/` : `${BASE_URL}${path}`;
